import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { parametersApi } from '../../services/api';

export const fetchParameters = createAsyncThunk(
  'parameters/list',
  async (params, { rejectWithValue }) => {
    try {
      const res = await parametersApi.list(params);
      return { items: res.data, pagination: res.pagination };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const createParameter = createAsyncThunk(
  'parameters/create',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await parametersApi.create(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const updateParameter = createAsyncThunk(
  'parameters/update',
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await parametersApi.update(id, payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const deleteParameter = createAsyncThunk(
  'parameters/delete',
  async (id, { rejectWithValue }) => {
    try {
      await parametersApi.remove(id);
      return Number(id);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

// Refactor 2026-04 (backend migration 0006): scope/period_id kaldirildi.
// filters artik sadece category tutuyor — Sistem Sabitleri tek global
// liste, donem-ozel override YOK.
const initialState = {
  items: [],
  status: 'idle',
  mutateStatus: 'idle',
  error: null,
  filters: { category: null },
  pagination: { total: 0, page: 1, size: 50 },
};

const parametersSlice = createSlice({
  name: 'parameters',
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetStatus(state) {
      state.mutateStatus = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchParameters.pending, (s) => { s.status = 'loading'; s.error = null; })
      .addCase(fetchParameters.fulfilled, (s, a) => {
        s.status = 'succeeded';
        s.items = a.payload.items;
        if (a.payload.pagination) s.pagination = a.payload.pagination;
      })
      .addCase(fetchParameters.rejected, (s, a) => { s.status = 'failed'; s.error = a.payload; })

      .addCase(createParameter.pending, (s) => { s.mutateStatus = 'loading'; })
      .addCase(createParameter.fulfilled, (s, a) => {
        s.mutateStatus = 'succeeded';
        s.items.unshift(a.payload);
      })
      .addCase(createParameter.rejected, (s, a) => { s.mutateStatus = 'failed'; s.error = a.payload; })

      .addCase(updateParameter.fulfilled, (s, a) => {
        const i = s.items.findIndex((p) => p.id === a.payload.id);
        if (i >= 0) s.items[i] = a.payload;
      })

      .addCase(deleteParameter.fulfilled, (s, a) => {
        s.items = s.items.filter((p) => p.id !== a.payload);
      });
  },
});

export const { setFilter, resetStatus } = parametersSlice.actions;
export default parametersSlice.reducer;
